import { DatePicker } from "@material-ui/pickers";
import {
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
  useTranslate,
} from "react-admin";
import { useAppData } from "../../../common/hooks/useAppData";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
import { ReportClient } from "../../common/reports/ReportClient";
import AutocompleteArrayInputWithSelectAll from "./AutocompleteArrayInputWithSelectAll";
import { reportFormats } from "../reportUtils";

interface Props extends RouteComponentProps {}

export const IftaMileageReport = (props: Props) => {
  const translate = useTranslate();
  useAuthenticated();
  const fuelTypes = useAppData((x) => x.fuelTypes) ?? [];
  const states = useAppData((x) => x.countries[0].states) ?? [];

  const fuelTypeChoices = fuelTypes.map((x) => ({
    id: x,
    name: translate(`appData.fuelTypes.${x}`),
  }));

  return (
    <ReportClient>
      <ReportForm
        reportName="ifta-report"
        {...props}
        title="resources.reports.iftaMileage.name"
        submitMethod={(x) => x.reportIftamileagereportPost}
      >
        <GenericDateOrTimePicker
          PickerComponent={DatePicker}
          source="dateFrom"
          options={{
            autoOk: true,
            format: "MMMM do yyyy",
          }}
          validate={required()}
        />
        <GenericDateOrTimePicker
          PickerComponent={DatePicker}
          source="dateTo"
          options={{
            autoOk: true,
            format: "MMMM do yyyy",
          }}
          validate={required()}
        />
        <ReferenceInput
          validate={required()}
          reference={resourceNames.ADMIN_COMPANIES}
          source="companyId"
        >
          <SelectInput />
        </ReferenceInput>
        <SelectInput
          source="fuelType"
          choices={fuelTypeChoices}
          validate={required()}
        />
        <AutocompleteArrayInputWithSelectAll
          source="stateIds"
          label="States"
          choices={states}
          validate={required()}
          variant="outlined"
          style={{ width: "50%" }}
        />
        <SelectInput
          source="reportFormat"
          choices={reportFormats}
          validate={required()}
        />
      </ReportForm>
    </ReportClient>
  );
};
